<template>
  <div>
    <v-snackbar top color = "white"
      v-model="snackbar"
      absolute
      class="mapSnackbar" 
      :timeout = "0"
    >
      <font
        color = "black"
      >
        Marcá el centro de tu equipo
      </font>
    </v-snackbar>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        snackbar: true
      };
    }
  };
</script>


// WEBPACK FOOTER //
// DeviceCenterInputSnackbar.vue?9eb4b89a